import * as React from 'react';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { Validators, DatePickerRangeField } from './Fields/_Fields';
import { withTranslation  } from 'react-i18next';
import {compose} from 'redux';

type ConnectedProps = {
    t?: Function;
};

const TerminalInstallationReport = (props: InjectedFormProps & ConnectedProps) => {
    const { handleSubmit, pristine, submitting, t} = props;
    return (
        <form className="form form--SearchHistoryLogAlerts" onSubmit={handleSubmit}>
            <Field
                name="dateRangeFromTo"
                component={DatePickerRangeField}
                type="text"
                placeholder={t('dateRange')}
                label={t('dateRange')}
                validate={[Validators.required]}
                endDateLabel={t('endDate')}
                startDateLabel={t('startDate')}
                dateRangePlaceholder={t('dateRangePlaceholder')}
            />
            <div className="form__fields-wrapper form__fields-wrapper--center">
                <button disabled={submitting || pristine} className="btn btn--blue" type="submit">
                    {t('generateReport')}
                </button>
            </div>
        </form>
    );
};

export default compose(
    withTranslation (['forms', 'errors', 'carDetails']),
    reduxForm({
        form: 'CarMainReport',
        enableReinitialize: true,
        keepDirtyOnReinitialize: true
    })
)(TerminalInstallationReport) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/Layout/Form/TerminalInstallationReportForm.tsx